import { useEffect } from 'react'

// AK-252: the real page lives on the info site, linked from the footer.
const Privacy = () => {
  useEffect(() => {
    window.location.replace('https://www.info.akedo.gg/privacy-policy')
  }, [])
  return null
}

export default Privacy
